"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var qm = _interopRequireWildcard(require("@/api/qm"));
var _axios = _interopRequireDefault(require("axios"));
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
var _store = _interopRequireDefault(require("@/store"));
var _index = _interopRequireDefault(require("./info/index.vue"));
var _task = _interopRequireDefault(require("./info/task.vue"));
var _selectMixins = _interopRequireDefault(require("@/mixins/selectMixins"));
var _merchant = require("@/api/merchant");
var _elementChinaAreaData = require("element-china-area-data");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'qmCarOrderList',
  components: {
    detailsOrder: _index.default,
    fileRecordList: _task.default
  },
  mixins: [_selectMixins.default],
  data: function data() {
    return {
      merchantCityData: _elementChinaAreaData.provinceAndCityData,
      dialogVisible: false,
      visibleFileRecord: false,
      //履历
      type: 1,
      fromList: this.$constants.fromList,
      isChecked: false,
      listLoading: false,
      loading: false,
      qmOrderInfo: {},
      headerNum: [{
        count: '',
        type: '1',
        title: '青民车辆核销订单列表'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableOrgData: [],
      userOptions: [],
      tableSupplierData: [],
      tableFrom: {
        page: 1,
        limit: 20,
        startDate: '',
        endDate: '',
        orderNumber: '',
        storeId: '',
        orgId: '',
        supplierId: '',
        code: '',
        serviceOrderNumber: '',
        vehicleNature: '',
        licensePlate: ''
      },
      autoUpdate: true,
      timeVal: [],
      merData: {},
      merId: 0,
      keyNum: 0,
      isDisabled: false,
      indexKey: 0,
      shopInfo: {},
      keyUrl: '',
      unitNameFilterBySup: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var curDate = new Date().getTime();
          var six = 1000 * 3600 * 24 * 360;
          var sixMonths = curDate - six;
          return time.getTime() >= new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 3600 * 1000 - 1) || time.getTime() <= sixMonths;
        }
      }
    };
  },
  mounted: function mounted() {
    this.getInfo();
    this.getOrgList();
    this.getList(1);
  },
  methods: {
    openDDCityRules: function openDDCityRules(data) {
      console.log(data);
      this.tableFrom.cityId = data.slice(-1)[0];
      console.log(this.tableFrom);
      this.getList(1);
    },
    // 获取商户信息
    getInfo: function getInfo() {
      var _this = this;
      (0, _merchant.getBaseInfoApi)().then(function (res) {
        _this.merData = res;
      }).catch(function () {});
    },
    handlerRecord: function handlerRecord() {
      var _this2 = this;
      this.visibleFileRecord = true;
      this.$nextTick(function () {
        _this2.$refs.fileRecord.getList(1, 1);
      });
    },
    handlerDetail: function handlerDetail(data) {
      this.qmOrderInfo = data;
      this.$refs.qmOrderDetail.dialogVisible = true;
      this.$refs.qmOrderDetail.getDetail(data);
    },
    getOrgList: function getOrgList() {
      var _this3 = this;
      qm.qmOrgListApi().then(function (res) {
        _this3.tableOrgData = res;
      });
    },
    exportsTask: function exportsTask() {
      var _this4 = this;
      qm.qmExportExcelTaskApi({
        page: 1,
        limit: 100,
        start_service_date: this.tableFrom.startDate,
        end_service_date: this.tableFrom.endDate,
        institution_order_number: this.tableFrom.orderNumber,
        vendor_order_number: this.tableFrom.serviceOrderNumber,
        vehicle_nature: this.tableFrom.vehicleNature,
        license_plate: this.tableFrom.licensePlate,
        order_organization_id: this.tableFrom.orgId,
        supplier_id: this.tableFrom.supplierId,
        service_store_id: this.tableFrom.storeId,
        code: this.code
      }).then(function (res) {
        _this4.$message({
          showClose: true,
          type: 'success',
          dangerouslyUseHTMLString: true,
          message: '正在下载中...;<strong> <el-button type="text" @click="handlerRecord()">查看详情</el-button></strong>'
        });
      }).catch(function (res) {
        _this4.$message.error(res);
      });
    },
    exports: function exports() {
      var data = {
        page: 1,
        limit: this.tableData.total,
        start_service_date: this.tableFrom.startDate,
        end_service_date: this.tableFrom.endDate,
        institution_order_number: this.tableFrom.orderNumber,
        vendor_order_number: this.tableFrom.serviceOrderNumber,
        vehicle_nature: this.tableFrom.vehicleNature,
        license_plate: this.tableFrom.licensePlate,
        order_organization_id: this.tableFrom.orgId,
        supplier_id: this.tableFrom.supplierId,
        service_store_id: this.tableFrom.storeId,
        code: this.code
      };
      this.axiosRequst(data);
    },
    axiosRequst: function axiosRequst(data) {
      // 发送请求之前做的
      var token = !_store.default.getters.token ? sessionStorage.getItem('token') : _store.default.getters.token;
      var service = _axios.default.create({
        baseURL: _settingMer.default.apiBaseURL,
        timeout: 60000,
        // 过期时间
        headers: {
          'Authori-zation': token
        }
      });
      service.post('admin/platform/qm/car/order/export/excel', data, {
        responseType: 'blob'
      }).then(function (result) {
        var blob = new Blob([result.data], {
          type: result.headers['content-type']
        });
        var url = window.URL.createObjectURL(blob);
        var dom = document.createElement('a');
        var temp = Date.now() + '数据统计.xlsx';
        dom.style.display = 'none';
        dom.href = url;
        dom.setAttribute('download', temp);
        document.body.appendChild(dom);
        dom.click();
        document.body.removeChild(dom);
      }).catch(function (err) {
        console.log('err :', err);
      });
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      if (e) {
        this.tableFrom.startDate = e[0];
        this.tableFrom.endDate = e[1];
        this.getList(1);
      } else {
        this.tableFrom.startDate = '';
        this.tableFrom.endDate = '';
      }
    },
    /**
     *  列表
     */
    getList: function getList(num) {
      var _this5 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      qm.qmCarOrderListApi({
        page: this.tableFrom.page,
        limit: this.tableFrom.limit,
        start_service_date: this.tableFrom.startDate,
        end_service_date: this.tableFrom.endDate,
        institution_order_number: this.tableFrom.orderNumber,
        vendor_order_number: this.tableFrom.serviceOrderNumber,
        vehicle_nature: this.tableFrom.vehicleNature,
        license_plate: this.tableFrom.licensePlate,
        order_organization_id: this.tableFrom.orgId,
        supplier_id: this.tableFrom.supplierId,
        service_store_id: this.tableFrom.storeId,
        code: this.code
      }).then(function (res) {
        _this5.tableData.data = res.list;
        _this5.tableData.total = res.total;
        _this5.listLoading = false;
      }).catch(function (res) {
        _this5.listLoading = false;
        _this5.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    },
    getChange: function getChange() {
      this.getList(1);
      this.dialogVisible = false;
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    }
  }
};